import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, Globe2, Clock, DollarSign } from "lucide-react";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

const COUNTRIES = [
  { value: "any", label: "Any country" },
  { value: "India", label: "🇮🇳 India" },
  { value: "Nepal", label: "🇳🇵 Nepal" },
  { value: "Bhutan", label: "🇧🇹 Bhutan" },
  { value: "Sri Lanka", label: "🇱🇰 Sri Lanka" },
  { value: "Maldives", label: "🇲🇻 Maldives" },
  { value: "Thailand", label: "🇹🇭 Thailand" },
  { value: "UAE", label: "🇦🇪 UAE (Dubai)" },
];

const DURATIONS = [
  { value: "any", label: "Any length" },
  { value: "1-4", label: "1-4 days" },
  { value: "5-7", label: "5-7 days" },
  { value: "8-12", label: "8-12 days" },
  { value: "13+", label: "13+ days" },
];

const BUDGETS = [
  { value: "any", label: "Any budget" },
  { value: "0-500", label: "Under $500" },
  { value: "500-1000", label: "$500 - $1,000" },
  { value: "1000-2000", label: "$1,000 - $2,000" },
  { value: "2000+", label: "$2,000+" },
];

export default function AdvancedSearch() {
  const nav = useNavigate();
  const [country, setCountry] = useState("any");
  const [duration, setDuration] = useState("any");
  const [budget, setBudget] = useState("any");

  const search = (e) => {
    e?.preventDefault?.();
    const params = new URLSearchParams();
    if (country !== "any") params.set("country", country);
    if (duration !== "any") params.set("duration", duration);
    if (budget !== "any") params.set("budget", budget);
    nav(`/tours?${params.toString()}`);
  };

  return (
    <form
      onSubmit={search}
      data-testid="advanced-search"
      className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-2 bg-white/95 backdrop-blur p-2 rounded-sm border border-white/20 shadow-xl max-w-4xl"
    >
      <div className="flex items-center gap-2 px-3 bg-cream rounded-sm">
        <Globe2 className="w-4 h-4 text-saffron flex-shrink-0" />
        <Select value={country} onValueChange={setCountry}>
          <SelectTrigger data-testid="search-country" className="border-0 bg-transparent shadow-none h-11 px-0 focus:ring-0">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {COUNTRIES.map((c) => <SelectItem key={c.value} value={c.value}>{c.label}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div className="flex items-center gap-2 px-3 bg-cream rounded-sm">
        <Clock className="w-4 h-4 text-saffron flex-shrink-0" />
        <Select value={duration} onValueChange={setDuration}>
          <SelectTrigger data-testid="search-duration" className="border-0 bg-transparent shadow-none h-11 px-0 focus:ring-0">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {DURATIONS.map((d) => <SelectItem key={d.value} value={d.value}>{d.label}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div className="flex items-center gap-2 px-3 bg-cream rounded-sm">
        <DollarSign className="w-4 h-4 text-saffron flex-shrink-0" />
        <Select value={budget} onValueChange={setBudget}>
          <SelectTrigger data-testid="search-budget" className="border-0 bg-transparent shadow-none h-11 px-0 focus:ring-0">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {BUDGETS.map((b) => <SelectItem key={b.value} value={b.value}>{b.label}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <button
        type="submit"
        data-testid="search-submit"
        className="bg-saffron text-white px-6 h-12 font-medium text-sm uppercase tracking-wider hover:bg-saffron-600 transition-colors rounded-sm flex items-center justify-center gap-2"
      >
        <Search className="w-4 h-4" /> Search
      </button>
    </form>
  );
}
